module.exports = __webpack_public_path__ + "static/media/expand-plus.e985ae67.svg";